export const USER_TOKEN = "userToken"
export const AUTH_TOKEN_CHANGED_EVENT = "auth-token-changed"
export const getAuthToken = (): string | null => {
  try {
    return localStorage.getItem(USER_TOKEN)
  } catch {
    return null
  }
}

export const setAuthToken = (token: string): void => {
  try {
    localStorage.setItem(USER_TOKEN, token)
  } catch {
    // Some browsers/policies block storage in restricted contexts.
    // Keep app flow alive and still notify listeners.
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(AUTH_TOKEN_CHANGED_EVENT))
  }
}

export const removeAuthToken = (): void => {
  try {
    localStorage.removeItem(USER_TOKEN)
  } catch {
    // Storage may be unavailable; still notify listeners.
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(AUTH_TOKEN_CHANGED_EVENT))
  }
}
